module.exports = __webpack_public_path__ + "static/media/pb_howto_desktop_EN.c7f1a8c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pb_howto_desktop_EN.png
// module id = 708
// module chunks = 0